import { render, staticRenderFns } from "./GaleriaEquipo.vue?vue&type=template&id=a428f69a&scoped=true&"
import script from "./GaleriaEquipo.vue?vue&type=script&lang=js&"
export * from "./GaleriaEquipo.vue?vue&type=script&lang=js&"
import style0 from "./GaleriaEquipo.vue?vue&type=style&index=0&id=a428f69a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a428f69a",
  null
  
)

export default component.exports